<template>
  <div>
    <flag-claims-dialog
      v-if="claimSubmission"
      :items="[claimSubmission.Id]"
      :model="flagsDialog"
      @close="closeFlagsDialog"
    />
    <v-dialog v-model="adjudicateAllDialog" persistent width="400" class="mx-0">
      <v-card max-width="400">
        <v-card-title class="primary white--text mb-6 py-2">
          <v-icon dark class="mr-2">rules</v-icon>
          {{ $t("components.new_claim.adjudicate_all_dialog.title") }}
        </v-card-title>
        <v-card-text class="text-subtitle-1 font-weight-medium">
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions class="justify-end pr-6">
          <v-btn text @click="adjudicateAllDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="tryAdjudicateAll">
            {{ $t("globals.adjudicate") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="saving" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="shortcutsDialog" persistent max-width="800">
      <material-card
        icon="share"
        :color="$vuetify.theme.themes.light.secondary"
        :title="$t('components.claim_submission.shortcuts')"
      >
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex
                xs12
                v-for="(explanation, index) in explanations"
                :key="index"
              >
                {{ $t(explanation) }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="shortcutsDialog = false" text>
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="removeFlagWarningDialog"
      persistent
      max-width="500"
      v-if="flagToDelete"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t("views.plangeneralparameters.remove_flag") }}
        </v-card-title>
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="removeFlagWarningDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="removeFlag">
            {{ $t("views.plangeneralparameters.remove_flag") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-actions
      v-if="
        claimSubmission &&
        claimSubmission.Id !== null &&
        claimSubmission.Id !== undefined
      "
    >
      <v-spacer />
      <v-chip
        v-for="flag in claimSubmission.Flags"
        :color="flag.Color"
        :text-color="flag.FontColor"
        :key="flag.Id"
        close
        style="margin-right: 5px"
        @click:close="
          flagToDelete = flag;
          removeFlagWarningDialog = true;
        "
      >
        {{ translate2(flag, "Name") }}
      </v-chip>
      <v-btn color="primary" @click="flagsDialog = true">
        {{ $t("components.flagmemberdialog.flag") }}
      </v-btn>
    </v-card-actions>
    <v-alert
      v-for="(error, i) in validationErrors"
      dense
      type="error"
      :key="i"
      dismissible
    >
      {{ error }}
    </v-alert>
    <v-tabs fixed-tabs v-model="tab">
      <v-tabs-slider color="primary"></v-tabs-slider>

      <v-tab :href="`#claim`">
        <span class="minfo">
          {{ $t("components.claim_submission.step2.title") }}
        </span>
      </v-tab>

      <v-tab-item :value="'claim'">
        <v-card flat>
          <v-card-actions>
            <member-editable-info
              :memberIdentity="memberIdentity"
              @reload-member-identity="$emit('reload-member-identity')"
            />
            <v-spacer></v-spacer>
            <template v-if="claimSubmission.CoverageType !== 'SickDay'">
              <v-col
                cols="12"
                sm="4"
                md="3"
                class="pa-4 text-right apply-text"
                align-self="center"
              >
                {{
                  $t(
                    "components.claims.claim_submission_tabs.is_predetermination"
                  )
                }}
              </v-col>
              <v-col cols="auto" class="pa-4" align-self="center">
                <v-switch
                  v-model="claimSubmission.IsPredetermined"
                  inset
                  color="primary"
                  class="mt-0 ml-5"
                  hide-details
                  :disabled="!isNew"
                ></v-switch>
              </v-col>
            </template>
            <v-col cols="auto" class="pa-4" align-self="center">
              <v-btn @click="shortcutsDialog = true" color="success">
                {{ $t("components.claim_submission.shortcuts") }}
              </v-btn>
            </v-col>
          </v-card-actions>
          <v-card-text>
            <v-row class="pa-0">
              <v-col cols="auto">
                <span class="minfo">
                  {{ $t("headers.pendinghourstasks.created_by") }}
                </span>
                <br />
                {{ claimSubmission.Creator }}
              </v-col>
              <!-- <v-col cols="auto">
                <span class="minfo">
                  {{ $t("components.new_claim.assigned_to") }}
                </span>
                <br />
                {{ user }}
              </v-col> -->
              <v-col cols="auto">
                <span class="minfo">
                  {{ $t("components.new_claim.created_at") }}
                </span>
                <br />
                {{ $helpers.formatDateTime(claimSubmission.Timestamp) }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card color="grey lighten-2">
          <claim-header
            :claimSubmission="claimSubmission"
            :patients="patients"
            @valid="
              valid.claimHeader = $event;
              valid.attachments = validAttachments();
              valid.notes = validNotes();
            "
            :disabled="review"
            :submitted="submitted"
            @provider="updateProvider"
          />
        </v-card>
        <!-- <claim-list
            :memberIdentity="memberIdentity"
            :claimSubmission="claimSubmission"
            @new-line="$emit('new-line')"
            @delete-line="$emit('delete-line', $event)"
          /> -->
        <claims-table
          :planIdentityId="planIdentityId"
          :claimSubmission="claimSubmission"
          :patients="patients"
          @valid="onValidClaimsTable"
          :submitted="submitted"
          :review="review"
          @reload-claim-submission="$emit('reload-claim-submission')"
          :planStartDate="planStartDate"
          @plan-benefit="planBenefit = $event"
          @covered-benefit="coveredBenefit = $event"
          @din="din = $event"
          @save="save"
          :isValidForAdjudicate="isValidForAdjudicate"
          :memberIdentityId="memberIdentity?memberIdentity.Id:null"
          :currentMemberGroupIdentityId="
            memberIdentity && memberIdentity.CurrentMembershipStatus !== null &&
            memberIdentity.CurrentMembershipStatus !== undefined
              ? memberIdentity.CurrentMembershipStatus.MemberGroupIdentity.Id
              : null
          "
          @sick-day-submission-settings="sickDaySubmissionSettings = $event"
        />
      </v-tab-item>

      <v-tab :href="`#member`">
        <span class="minfo">
          {{ $t("globals.member") }}
        </span>
      </v-tab>

      <v-tab-item :value="'member'">
        <v-card-actions>
          <member-editable-info
            :memberIdentity="memberIdentity"
            @reload-member-identity="$emit('reload-member-identity')"
          />
          <v-spacer></v-spacer>
          <template v-if="claimSubmission.CoverageType !== 'SickDay'">
            <v-col
              cols="12"
              sm="4"
              md="3"
              class="pa-4 text-right apply-text"
              align-self="center"
            >
              {{
                $t(
                  "components.claims.claim_submission_tabs.is_predetermination"
                )
              }}
            </v-col>
            <v-col cols="auto" class="pa-4" align-self="center">
              <v-switch
                v-model="claimSubmission.IsPredetermined"
                inset
                color="primary"
                class="mt-0 ml-5"
                hide-details
                :disabled="!isNew"
              ></v-switch>
            </v-col>
          </template>
          <v-col cols="auto" class="pa-4" align-self="center">
            <v-btn @click="shortcutsDialog = true" color="success">
              {{ $t("components.claim_submission.shortcuts") }}
            </v-btn>
          </v-col>
        </v-card-actions>
        <template v-if="memberIdentity">
          <member-details
            :memberIdentity="memberIdentity"
            @reload-member-identity="$emit('reload-member-identity')"
          />
        </template>
      </v-tab-item>

      <v-tab :href="`#attachments`">
        <span class="minfo">
          {{ $t("components.claims.claim_submission_tabs.attachments") }}
        </span>
      </v-tab>

      <v-tab-item :value="'attachments'">
        <v-card-actions>
          <member-editable-info
            :memberIdentity="memberIdentity"
            @reload-member-identity="$emit('reload-member-identity')"
          />
          <v-spacer></v-spacer>
          <template v-if="claimSubmission.CoverageType !== 'SickDay'">
            <v-col
              cols="12"
              sm="4"
              md="3"
              class="pa-4 text-right apply-text"
              align-self="center"
            >
              {{
                $t(
                  "components.claims.claim_submission_tabs.is_predetermination"
                )
              }}
            </v-col>
            <v-col cols="auto" class="pa-4" align-self="center">
              <v-switch
                v-model="claimSubmission.IsPredetermined"
                inset
                color="primary"
                class="mt-0 ml-5"
                hide-details
                :disabled="!isNew"
              ></v-switch>
            </v-col>
          </template>
          <v-col cols="auto" class="pa-4" align-self="center">
            <v-btn @click="shortcutsDialog = true" color="success">
              {{ $t("components.claim_submission.shortcuts") }}
            </v-btn>
          </v-col>
        </v-card-actions>
        <claim-files-table
          :claimSubmission="claimSubmission"
          :memberIdentity="memberIdentity"
          :planNumber="planNumber"
          :planName="planName"
          @valid="
            valid.attachments = validAttachments();
            valid.notes = validNotes();
            saveAfterFileOrNote();
          "
        />
      </v-tab-item>
      <v-tab :href="`#notes`">
        <span class="minfo">
          {{ $t("components.employers.employer_details.notes") }}
        </span>
      </v-tab>

      <v-tab-item :value="'notes'">
        <v-card-actions>
          <member-editable-info
            :memberIdentity="memberIdentity"
            @reload-member-identity="$emit('reload-member-identity')"
          />
          <v-spacer></v-spacer>
          <template v-if="claimSubmission.CoverageType !== 'SickDay'">
            <v-col
              cols="12"
              sm="4"
              md="3"
              class="pa-4 text-right apply-text"
              align-self="center"
            >
              {{
                $t(
                  "components.claims.claim_submission_tabs.is_predetermination"
                )
              }}
            </v-col>
            <v-col cols="auto" class="pa-4" align-self="center">
              <v-switch
                v-model="claimSubmission.IsPredetermined"
                inset
                color="primary"
                class="mt-0 ml-5"
                hide-details
                :disabled="!isNew"
              ></v-switch>
            </v-col>
          </template>
          <v-col cols="auto" class="pa-4" align-self="center">
            <v-btn @click="shortcutsDialog = true" color="success">
              {{ $t("components.claim_submission.shortcuts") }}
            </v-btn>
          </v-col>
        </v-card-actions>
        <note-list
          :claimSubmission="claimSubmission"
          @valid="
            valid.notes = validNotes();
            valid.attachments = validAttachments();
            saveAfterFileOrNote();
            $forceUpdate();
          "
        />
      </v-tab-item>

      <template
        v-if="
          payments !== null && payments !== undefined && payments.length > 0
        "
      >
        <v-tab :href="`#payments`">
          <span class="minfo">
            {{ $t("globals.payments") }}
          </span>
        </v-tab>

        <v-tab-item :value="'payments'">
          <v-card-actions>
            <member-editable-info
              :memberIdentity="memberIdentity"
              @reload-member-identity="$emit('reload-member-identity')"
            />
            <v-spacer></v-spacer>
            <template v-if="claimSubmission.CoverageType !== 'SickDay'">
              <v-col
                cols="12"
                sm="4"
                md="3"
                class="pa-4 text-right apply-text"
                align-self="center"
              >
                {{
                  $t(
                    "components.claims.claim_submission_tabs.is_predetermination"
                  )
                }}
              </v-col>
              <v-col cols="auto" class="pa-4" align-self="center">
                <v-switch
                  v-model="claimSubmission.IsPredetermined"
                  inset
                  color="primary"
                  class="mt-0 ml-5"
                  hide-details
                  :disabled="!isNew"
                ></v-switch>
              </v-col>
            </template>
            <v-col cols="auto" class="pa-4" align-self="center">
              <v-btn @click="shortcutsDialog = true" color="success">
                {{ $t("components.claim_submission.shortcuts") }}
              </v-btn>
            </v-col>
          </v-card-actions>
          <claim-submission-payments :payments="payments" />
        </v-tab-item>
      </template>
    </v-tabs>
    <v-card-text>
      <v-row>
        <v-col>
          <span>
            {{ $t("components.claims_history.header.total_submitted") }}
          </span>
          <span class="minfo">
            {{ $helpers.toCurrency(calculateTotalSubmitted()) }}
          </span>
        </v-col>
        <v-col>
          <span>{{ $t("components.claims_history.header.total_cob") }}</span>
          <span class="minfo">
            {{ $helpers.toCurrency(calculateTotalCOB()) }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="save" :disabled="!validForSave()">
        {{ $t("globals.save") }}
      </v-btn>
      <v-btn
        :disabled="!validForAdjudicate()"
        color="success"
        :loading="saving"
        @click="adjudicateAllDialog = true"
      >
        {{ $t("globals.adjudicate") }}
      </v-btn>
      <v-btn color="success" @click="submit" :disabled="!validForSubmit()">
        {{ $t("components.claims.claims_history_component.submit_claims") }}
      </v-btn>
      <v-spacer />
      <v-col
        cols="12"
        sm="4"
        md="3"
        class="pa-4 text-right apply-text"
        align-self="center"
      >
        {{
            $t("components.claims.claim_submission_tabs.bypass_fee_guide")
        }}
      </v-col>
      <v-col cols="auto" class="pa-4" align-self="center">
        <v-switch
          :disabled="!atLeastOneClaimInNewOrPendedState()"
          v-model="claimSubmission.OverrideFeeGuide"
          inset
          color="success"
          class="mt-0"
          hide-details
        ></v-switch>
      </v-col>
      <template
        v-if="
          hasHSA &&
          claimSubmission.CoverageType !== 'HSA' &&
          claimSubmission.CoverageType !== 'SickDay' &&
          !claimSubmission.IsPredetermined
        "
      >
        <v-col
          cols="12"
          sm="4"
          md="3"
          class="pa-4 text-right apply-text"
          align-self="center"
        >
          {{
            $t("components.claims.claim_submission_tabs.apply_remaining_hsa")
          }}
        </v-col>
        <v-col cols="auto" class="pa-4" align-self="center">
          <v-switch
            v-model="claimSubmission.ApplyRemainingToHCSA"
            inset
            color="success"
            class="mt-0"
            hide-details
          ></v-switch>
        </v-col>
      </template>
    </v-card-actions>
    <v-snackbar v-model="snackbar" color="success" :timeout="3000">
      {{ $t("globals.success") }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error" />
  </div>
</template>

<script>
// import ClaimList from "@/components/Claims/ClaimList.vue";
import ClaimsTable from "@/components/Claims/ClaimsTable.vue";
import MemberDetails from "@/components/Claims/MemberDetails.vue";
import ClaimHeader from "@/components/Claims/ClaimHeader.vue";
import ClaimFilesTable from "@/components/Claims/ClaimFilesTable.vue";
import NoteList from "./NoteList.vue";
import ErrorHandler from "../ErrorHandler.vue";
import { mapGetters, mapActions } from "vuex";
import MemberEditableInfo from "./MemberEditableInfo.vue";
import ClaimSubmissionPayments from "./ClaimSubmissionPayments.vue";
import FlagClaimsDialog from "@/components/Claims/FlagClaimsDialog.vue";
import { translate2 } from "../../trans2";

export default {
  components: {
    ClaimsTable,
    MemberDetails,
    ClaimHeader,
    ClaimFilesTable,
    NoteList,
    ErrorHandler,
    MemberEditableInfo,
    ClaimSubmissionPayments,
    FlagClaimsDialog,
  },

  props: [
    "memberIdentity",
    "claimSubmission",
    "patients",
    "planNumber",
    "planName",
    "submitted",
    "review",
    "planStartDate",
    "hasHSA",
    "planIdentityId",
    "isNew",
    "payments",
  ],
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  data() {
    return {
      tab: "claim",
      saving: false,
      snackbar: false,
      valid: {
        claimsTable: false,
        claimHeader: false,
        attachments: false,
        notes: false,
      },
      error: null,
      shortcutsDialog: false,
      explanations: [
        "shift+enter: new line",
        "ctrl+;: row up, moves the focus to the same field of the previous row",
        "ctrl+/: row down, moves the focus to the same field of the next row",
        "ctrl+c: copy line, copies the row of the field that has the focus in the memory",
        "ctrl+v: paste line, pastes row in memory as a new row in the end",
        "ctrl+x: delete line, deletes the row of the field that has the focus",
        "ctrl+left arrow: previous tab, navigate to previous tab in a circle where before the first item exists the last",
        "ctrl+right arrow: next tab, navigate to next tab in a circle where after the last item exists the first",
      ],
      planBenefit: {},
      coveredBenefit: {},
      provider: null,
      din: {},
      originalSubmission: null,
      validationErrors: [],
      adjudicateAllDialog: false,
      isValidForAdjudicate: false,
      flagsDialog: false,
      flagToDelete: null,
      removeFlagWarningDialog: false,
      sickDaySubmissionSettings: null,
    };
  },
  watch: {
    claimSubmission: {
      handler(v) {
        // console.log("claim submission watch: ", v);
        if (v !== null && v !== undefined) {
          this.originalSubmission = JSON.parse(JSON.stringify(v));
        } else {
          this.originalSubmission = null;
        }
      },
    },
    "claimSubmission.IsPredetermined": {
      handler() {
        this.valid.attachments = this.validAttachments();
      },
    },
  },
  created() {
    window.addEventListener("keydown", this.doCommand);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.doCommand);
  },
  mounted() {
    if (this.claimSubmission !== null && this.claimSubmission !== undefined) {
      this.originalSubmission = JSON.parse(
        JSON.stringify(this.claimSubmission)
      );
      this.valid.attachments = this.validAttachments();
      this.valid.notes = this.validNotes();
    } else {
      this.originalSubmission = null;
    }
  },
  methods: {
    ...mapActions("claims", [
      "newClaimSubmission",
      "submitClaimSubmission",
      "updateClaimSubmission",
      "adjudicateClaimById",
      "flagClaims",
    ]),
    atLeastOneClaimInNewOrPendedState() {
      if (this.claimSubmission === null || this.claimSubmission === undefined) {
        return false;
      }
      if (this.claimSubmission.Claims === null || this.claimSubmission.Claims === undefined) {
        return false;
      }
      return this.claimSubmission.Claims.filter(o=>o.State === "New" || o.State === "Pended" || o.State === null || o.State === undefined).length > 0;
    },
    async removeFlag() {
      try {
        this.saving = true;
        await this.flagClaims({
          payload: {
            FlagIds: this.claimSubmission.Flags.filter(
              (o) => o.Id !== this.flagToDelete.Id
            ).map((o) => o.Id),
            SubmissionIds: [this.claimSubmission.Id],
          },
        });
        this.removeFlagWarningDialog = false;
        this.claimSubmission.Flags = this.claimSubmission.Flags.filter(
          (o) => o.Id !== this.flagToDelete.Id
        );
        this.flagToDelete = null;
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    closeFlagsDialog(flags) {
      this.claimSubmission.Flags = flags;
      this.flagsDialog = false;
    },
    calculateTotalSubmitted() {
      let total = 0;
      for (let c of this.claimSubmission.Claims) {
        let expenseAmount = parseFloat(c.ExpenseAmount);
        if (isNaN(expenseAmount)) {
          expenseAmount = 0.0;
        }
        let labFee = parseFloat(c.LabFee);
        if (isNaN(labFee)) {
          labFee = 0.0;
        }
        total = total + expenseAmount + labFee;
      }
      return total;
    },
    calculateTotalCOB() {
      let total = 0;
      for (let c of this.claimSubmission.Claims) {
        let cobAmount = parseFloat(c.COBAmount);
        if (isNaN(cobAmount)) {
          cobAmount = 0.0;
        }
        total = total + cobAmount;
      }
      return total;
    },
    updateProvider(provider) {
      this.provider = provider;
      // console.log("provider update: ", provider);
    },
    doCommand(evt) {
      // console.log("key press", evt.keyCode, evt.target.value, evt);
      // if (evt.keyCode === 112 && evt.ctrlKey) {
      //   this.tab = "claim";
      // } else if (evt.keyCode === 113 && evt.ctrlKey) {
      //   this.tab = "member";
      // } else if (evt.keyCode === 114 && evt.ctrlKey) {
      //   this.tab = "attachments";
      // } else if (evt.keyCode === 115 && evt.ctrlKey) {
      //   this.tab = "notes";
      // }
      if (evt.keyCode === 37 && evt.ctrlKey) {
        // left
        this.tabLeft();
      } else if (evt.keyCode === 39 && evt.ctrlKey) {
        // right
        this.tabRight();
      }
    },
    tabLeft() {
      switch (this.tab) {
        case "claim": {
          this.tab = "notes";
          break;
        }
        case "member": {
          this.tab = "claim";
          break;
        }
        case "attachments": {
          this.tab = "member";
          break;
        }
        case "notes": {
          this.tab = "attachments";
          break;
        }
      }
    },
    tabRight() {
      switch (this.tab) {
        case "claim": {
          this.tab = "member";
          break;
        }
        case "member": {
          this.tab = "attachments";
          break;
        }
        case "attachments": {
          this.tab = "notes";
          break;
        }
        case "notes": {
          this.tab = "claim";
          break;
        }
      }
    },
    onValidClaimsTable(validClaimsTable) {
      // console.log("----------------on valid claims table: ", validClaimsTable);
      this.valid.claimsTable = validClaimsTable;
      this.valid.attachments = this.validAttachments();
      this.valid.notes = this.validNotes();
    },
    validClaimSubmission() {
      // console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~", this.valid)
      return (
        this.valid.claimsTable &&
        this.valid.claimHeader &&
        this.valid.attachments &&
        this.valid.notes
      );
    },
    sameObject(original, clone) {
      // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$")
      if (original === null || original === undefined) {
        // console.log("is same 1");
        return clone === null || clone === undefined;
      }
      if (clone === null || clone === undefined) {
        // console.log("is same 2");
        return false;
      }

      const originalKeys = Object.keys(original);
      const cloneKeys = Object.keys(clone);
      if (originalKeys.length !== cloneKeys.length) {
        // console.log("is same 3", originalKeys, cloneKeys);
        return false;
      }

      let isSame = true;
      for (let key of originalKeys) {
        if (original[key] === null || original[key] === undefined) {
          isSame = clone[key] === null || clone[key] === undefined;
        } else if (typeof original[key] === "object") {
          if (Array.isArray(original[key])) {
            if (!Array.isArray(clone[key])) {
              // console.log("is same 4");
              return false;
            }
            for (let i = 0; i < original[key].length; i++) {
              // console.log(original[key][i], clone[key][i]);
              isSame = this.sameObject(original[key][i], clone[key][i]);
              if (!isSame) {
                // console.log("is same 5");
                return false;
              }
            }
          } else {
            isSame = this.sameObject(original[key], clone[key]);
          }
        } else {
          if (
            key === "DateOfService" &&
            clone[key].length > original[key].length
          ) {
            const a = clone[key].slice(0, clone[key].length - 5) + "Z";
            clone[key] = a;
          }
          isSame = original[key] === clone[key];
        }
        if (!isSame) {
          // console.log("is same 6", key, original[key], clone[key]);
          return false;
        }
      }
      return isSame;
    },
    validAttachments() {
      // console.log(
      //   "v a l i d  a t t a c h m e n t s",
      //   this.claimSubmission.IsPredetermined
      // );
      this.validationErrors = [];
      if (
        this.claimSubmission.UserType === "DentalProvider" ||
        this.claimSubmission.UserType === "PharmacyProvider" ||
        this.claimSubmission.UserType === "HealthProvider" ||
        this.claimSubmission.IsPredetermined
      ) {
        return true;
      }

      // console.log(this.claimSubmission);
      // if (this.claimSubmission.Proofs.length === 0) {
      //   this.validationErrors.push(
      //     this.$t("claim_submission.validation_errors.no_attachments")
      //   );
      //   return false;
      // }
      for (let i = 0; i < this.claimSubmission.Claims.length; i++) {
        if (
          this.claimSubmission.Claims[i].State === "Deleted" ||
          this.claimSubmission.Claims[i].State === "Rejected"
        ) {
          break;
        }
        if (this.claimSubmission.CoverageType === "SickDay") {
          if (
            this.sickDaySubmissionSettings !== null &&
            this.sickDaySubmissionSettings !== undefined
          ) {
            if (this.sickDaySubmissionSettings.RequiresSickDayForm) {
              const sickDayForm = this.claimSubmission.Proofs.filter(
                (o) =>
                  o.ClaimLines.indexOf(i + 1) > -1 &&
                  o.ProofType === "SickDayForm"
              );
              if (sickDayForm.length === 0) {
                this.validationErrors.push(
                  this.$t(
                    "claim_submission.validation_errors.no_sick_day_form_at_line_{0}",
                    [i + 1]
                  )
                );
                return false;
              }
            }
            if (this.sickDaySubmissionSettings.RequiresDoctorsNote) {
              const f = this.claimSubmission.Proofs.filter(
                (o) =>
                  o.ClaimLines.indexOf(i + 1) > -1 &&
                  o.ProofType === "DoctorNote"
              );
              if (f.length === 0) {
                this.validationErrors.push(
                  this.$t(
                    "claim_submission.validation_errors.no_doctor_note_at_line_{0}",
                    [i + 1]
                  )
                );
                return false;
              }
            }
            if (this.sickDaySubmissionSettings.RequiresEmployerConfirmation) {
              const f = this.claimSubmission.Proofs.filter(
                (o) =>
                  o.ClaimLines.indexOf(i + 1) > -1 &&
                  o.ProofType === "EmployerConfirmation"
              );
              if (f.length === 0) {
                this.validationErrors.push(
                  this.$t(
                    "claim_submission.validation_errors.no_employer_confirmation_at_line_{0}",
                    [i + 1]
                  )
                );
                return false;
              }
            }
          }
        } else {
          const expenseFile = this.claimSubmission.Proofs.filter(
            (o) => o.ClaimLines.indexOf(i + 1) > -1 && o.ProofType === "Expense"
          );
          if (expenseFile.length === 0) {
            this.validationErrors.push(
              this.$t(
                "claim_submission.validation_errors.no_expense_at_line_{0}",
                [i + 1]
              )
            );
            return false;
          }
          if (
            // this.claimSubmission.Claims[i].COBAmount !== null &&
            // this.claimSubmission.Claims[i].COBAmount !== undefined
            this.claimSubmission.Claims[i].HasCOB
          ) {
            const cobFile = this.claimSubmission.Proofs.filter(
              (o) => o.ClaimLines.indexOf(i + 1) > -1 && o.ProofType === "COB"
            );
            if (cobFile.length === 0) {
              this.validationErrors.push(
                this.$t(
                  "claim_submission.validation_errors.no_cob_at_line_{0}",
                  [i + 1]
                )
              );
              return false;
            }
          }
          const benefit =
            this.planBenefit[this.claimSubmission.Claims[i].Identifier];
          if (benefit && benefit.RequiresReferral) {
            const refFile = this.claimSubmission.Proofs.filter(
              (o) =>
                o.ClaimLines.indexOf(i + 1) > -1 && o.ProofType === "Referral"
            );
            if (refFile.length === 0) {
              this.validationErrors.push(
                this.$t(
                  "claim_submission.validation_errors.no_ref_at_line_{0}",
                  [i + 1]
                )
              );
              return false;
            }
            this.claimSubmission.Claims[i].ReferralDate =
              refFile[0].ReferralDate;
          }
        }
      }
      return true;
    },
    validNotes() {
      // console.log("valid-notes");
      for (let i = 0; i < this.claimSubmission.Claims.length; i++) {
        const benefit =
          this.planBenefit[this.claimSubmission.Claims[i].Identifier];
        if (benefit && benefit.RequiresLetter) {
          const note = this.claimSubmission.Notes.filter(
            (o) => o.ClaimLines.indexOf(i + 1) > -1
          );
          if (note.length === 0) {
            this.validationErrors.push(
              this.$t(
                "claim_submission.validation_errors.no_letter_at_line_{0}",
                [i + 1]
              )
            );
            return false;
          }
        }
      }
      return true;
    },
    validForSave() {
      // if (this.claimSubmission.Claims.length === 0) {
      //   return false;
      // }
      // let valid = true;
      // for (const claim of this.claimSubmission.Claims) {
      //   valid = this.isValidClaim(claim);
      //   if (!valid) {
      //     break;
      //   }
      // }
      // return valid;
      // console.log(this.valid.claimsTable);
      return this.valid.claimsTable;
    },
    // isValidClaim(claim) {
    //   return (
    //     claim.Patient !== null &&
    //     claim.Patient !== undefined &&
    //     claim.Benefit !== null &&
    //     claim.Benefit !== undefined &&
    //     claim.DateOfService !== null &&
    //     claim.DateOfService !== undefined &&
    //     claim.ExpenseAmount !== null &&
    //     claim.ExpenseAmount !== undefined
    //   );
    // },
    saveAfterFileOrNote() {
      if (this.validForSave()) {
        this.save();
      }
    },
    createPayload(item) {
      const claimSubmission = JSON.parse(JSON.stringify(item));
      if (this.memberIdentity) {
        claimSubmission.MemberId = this.memberIdentity?this.memberIdentity.Id:null;
        claimSubmission.MemberFirstName = this.memberIdentity.CurrentMember.FirstName;
        claimSubmission.MemberLastName = this.memberIdentity.CurrentMember.LastName;
        claimSubmission.MemberCertificate = this.memberIdentity.MemberIdentification.Certificate;
      }

      claimSubmission.PlanId = this.planIdentityId;
      claimSubmission.PlanNumber = this.planNumber;
      for (let i = 0; i < claimSubmission.Claims.length; i++) {
        // console.log("#################aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa##########################", JSON.stringify(claimSubmission.Claims[i].PlanBenefit))
        // console.log("CoveredBenefit", JSON.stringify(claimSubmission.Claims[i].CoveredBenefit))
        if (
          claimSubmission.Claims[i].PlanBenefit !== null &&
          claimSubmission.Claims[i].PlanBenefit !== undefined
        ) {
          if (typeof claimSubmission.Claims[i].PlanBenefit !== "object") {
            const planBenefit =
            this.planBenefit[claimSubmission.Claims[i].Identifier];
          // if (planBenefit !== null && planBenefit !== undefined) {
          //   claimSubmission.Claims[i].PlanBenefit = planBenefit;
          // }
          claimSubmission.Claims[i].PlanBenefitId = planBenefit.Id;
          }
          //  else {
          //   claimSubmission.Claims[i].PlanBenefitId = claimSubmission.Claims[i].PlanBenefit.Id;
          // }

        }
        delete claimSubmission.Claims[i].PlanBenefit;
        if (claimSubmission.Claims[i].ToothCode) {
          claimSubmission.Claims[i].ToothCodeId =
            claimSubmission.Claims[i].ToothCode.Id;
        }

        if (claimSubmission.Claims[i].CoveredBenefit) {
          claimSubmission.Claims[i].HSACoveredBenefitId =
            claimSubmission.Claims[i].CoveredBenefit.Id;

          delete claimSubmission.Claims[i].CoveredBenefitCategory;
        }
        // if (claimSubmission.Claims[i].CoveredBenefit) {
        //   if (typeof claimSubmission.Claims[i].CoveredBenefit !== "object") {
        //     const coveredBenefit =
        //       this.coveredBenefit[claimSubmission.Claims[i].Identifier];
        //     if (coveredBenefit !== null && coveredBenefit !== undefined) {
        //       claimSubmission.Claims[i].HSACoveredBenefitId = coveredBenefit.Id;
        //     }
        //   }
        //   delete claimSubmission.Claims[i].CoveredBenefit;
        // }

        claimSubmission.Claims[i].MemberId = claimSubmission.MemberId;

        if (claimSubmission.CoverageType === "Dental") {
          if (
            claimSubmission.Patient !== null &&
            claimSubmission.Patient !== undefined
          ) {
            claimSubmission.Claims[i].Patient = claimSubmission.Patient;
          }
        }
        if (
          claimSubmission.Claims[i].Patient !== null &&
          claimSubmission.Claims[i].Patient !== undefined
        ) {
          if (
            claimSubmission.Claims[i].Patient.Id !== claimSubmission.MemberId
          ) {
            claimSubmission.Claims[i].DependantId =
              claimSubmission.Claims[i].Patient.IdentityId;
          } else {
            delete claimSubmission.Claims[i].DependantId
          }
          claimSubmission.Claims[i].FirstName =
            claimSubmission.Claims[i].Patient.FirstName;
          claimSubmission.Claims[i].LastName =
            claimSubmission.Claims[i].Patient.LastName;
        }
        claimSubmission.Claims[i].Line = i + 1;
        claimSubmission.Claims[i].PlanId = this.planIdentityId;

        if (
          claimSubmission.Claims[i].DIN !== null &&
          claimSubmission.Claims[i].DIN !== undefined
        ) {
          if (typeof claimSubmission.Claims[i].DIN === "object") {
            claimSubmission.Claims[i].DIN = claimSubmission.Claims[i].DIN.Din;
          } else {
            const din = this.din[claimSubmission.Claims[i].Identifier];
            if (din !== undefined) {
              claimSubmission.Claims[i].DIN = din.Din;
            }
          }
        }

      }
      if (
        claimSubmission.Office !== null &&
        claimSubmission.Office !== undefined
      ) {
        claimSubmission.OfficeId = claimSubmission.Office.OfficeId;
      }
      if (claimSubmission.Notes) {
        claimSubmission.Notes = claimSubmission.Notes.filter(
          (o) => o.Timestamp !== undefined
        );
      }
      // console.log("claim submission: ", claimSubmission);
      return claimSubmission;
    },

    async save() {
      this.saving = true;
      const claimSubmission = this.createPayload(this.claimSubmission);
      if (this.provider !== null && this.provider !== undefined) {
        claimSubmission.ProviderId = this.provider.Id;
        // claimSubmission.Provider = this.provider;
      }
      try {
        // console.log("-----------------------", claimSubmission.Id);
        if (claimSubmission.Id !== null && claimSubmission.Id !== undefined) {
          await this.updateClaimSubmission({
            id: claimSubmission.Id,
            payload: claimSubmission,
          });
          this.$emit("reload-claim-submission", this.claimSubmission.Id);
        } else {
          this.claimSubmission.Id = (
            await this.newClaimSubmission({
              payload: claimSubmission,
            })
          ).data;
          this.$emit("reload-claim-submission", this.claimSubmission.Id);
        }

        this.snackbar = true;
        // console.log(this.claimSubmission.Id);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async submit() {
      this.saving = true;
      try {
        await this.submitClaimSubmission({
          id: this.claimSubmission.Id,
        });
        this.$emit("close");
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        this.snackbar = true;
      }
    },
    isChanged() {
      const claimSubmission = this.createPayload(this.claimSubmission);
      const originalSubmission = this.createPayload(this.originalSubmission);
      const isSameObject =
        this.sameProvider() &&
        this.sameObject(originalSubmission, claimSubmission);
      // console.log("cst: ", isSameObject);
      return !isSameObject;
    },
    validForAdjudicate() {
      // console.log("Valif for adjuducate ----------------------------------------")
      if (
        this.claimSubmission === null ||
        this.claimSubmission === undefined ||
        this.originalSubmission === null ||
        this.originalSubmission === undefined
      ) {
        return false;
      }
      const validClaimSubmission = this.validClaimSubmission();
      const claimSubmission = this.createPayload(this.claimSubmission);
      const originalSubmission = this.createPayload(this.originalSubmission);
      const isSameObject =
        this.sameProvider() &&
        this.sameObject(originalSubmission, claimSubmission);
      const pendedClaimsExist =
        this.claimSubmission.Claims.filter((o) => o.State === "Pended").length >
        0;
      this.isValidForAdjudicate =
        validClaimSubmission && isSameObject && pendedClaimsExist;
      return this.isValidForAdjudicate;
    },
    validForSubmit() {
      if (
        this.claimSubmission === null ||
        this.claimSubmission === undefined ||
        this.originalSubmission === null ||
        this.originalSubmission === undefined
      ) {
        return false;
      }
      const validClaimSubmission = this.validClaimSubmission();
      const claimSubmission = this.createPayload(this.claimSubmission);
      const originalSubmission = this.createPayload(this.originalSubmission);
      // console.log("valid for adj claim", JSON.stringify(this.claimSubmission));
      // console.log("valid for adj orig", JSON.stringify(this.originalSubmission))
      // console.log(this.sameProvider())
      const isSameObject =
        this.sameProvider() &&
        this.sameObject(originalSubmission, claimSubmission);
      const newClaimsExist =
        this.claimSubmission.Claims.filter(
          (o) => o.State === "New" || o.State === undefined
        ).length > 0;
      // console.log(
      //   "!@#$%^&*()",
      //   this.claimSubmission.Id,
      //   validClaimSubmission,
      //   isSameObject,
      //   newClaimsExist,
      //   this.claimSubmission,
      //   this.originalSubmission
      // );
      return (
        this.claimSubmission.Id !== null &&
        this.claimSubmission.Id !== undefined &&
        validClaimSubmission &&
        isSameObject &&
        newClaimsExist
      );
    },
    sameProvider() {
      // console.log("******************************************************");
      // console.log(this.claimSubmission.ProviderId);
      // console.log(this.provider);
      if (this.provider === null || this.provider === undefined) {
        // console.log("bingo")
        return (
          this.claimSubmission.ProviderId === null ||
          this.claimSubmission.ProviderId === undefined ||
          this.claimSubmission.ProviderId ===
            "00000000-0000-0000-0000-000000000000"
        );
      }
      return this.provider.Id === this.claimSubmission.ProviderId;
    },
    async tryAdjudicateAll() {
      this.saving = true;
      const errors = [];
      for (let claim of this.claimSubmission.Claims) {
        try {
          await this.adjudicateClaimById({
            claimId: claim.Id,
          });
        } catch (error) {
          errors.push(error);
        }
      }
      this.$emit("reload-claim-submission");
      this.adjudicateAllDialog = false;
      if (errors.length === 0) {
        this.message =
          "components.claims.claims_table.adjudicated_successfully";
        this.snackbar = true;
      } else {
        this.error = "There were errors during the process";
      }

      this.saving = false;
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
